import {
  ThemeFluentComponentSettings,
  ThemeFluent,
  DarkThemeComponentSettings,
  DarkTheme
} from '@bingads-webui-theme-2018/theme-fluent';

export const themes = {
  light: {
    components: ThemeFluentComponentSettings,
    core: ThemeFluent,
  },
  dark: {
    components: DarkThemeComponentSettings,
    core: DarkTheme,
  },
};
